module.exports = __webpack_public_path__ + "media/31.a9be6720.mp3";